/* global Ad, google, googleMapsLoaded */
import clearConflictingFormParameters, { hasConflictingParameters } from '@PROJECT_ROOT/assets/desktop/js/search/clearConflictingParameters';
import configureFetchPlaces from '@PROJECT_ROOT/assets/shared/js/placesFetch';
import configureGetPrivateFilterForm from '@PROJECT_ROOT/assets/desktop/js/search/privateFilterForm';
import debounce from 'lodash/debounce';
import formClear from '@PROJECT_ROOT/assets/desktop/js/search/formClear';
import getAdriaticStyles from '@PROJECT_ROOT/assets/shared/js/map/GoogleMapsStyles';
import getFormatGooglePredictionsForAutocomplete from '@PROJECT_ROOT/assets/desktop/js/search/formatGoogleResults';
import googleAnalyticsSearchResults from '@PROJECT_ROOT/assets/desktop/js/search/googleAnalyticsSearchResults';
import isGoogleLocationId from '@PROJECT_ROOT/assets/shared/js/PrivateAccommodation/googleLocationId';
import loosenParameters from '@PROJECT_ROOT/assets/desktop/js/search/loosenParameters';
import makeFetchExternalAutocomplete from '@PROJECT_ROOT/assets/shared/js/externalAutocomplete';
import makeGetPlaceInfo from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/GooglePlaceInfo';
import MapSearch from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/MapSearch';
import showFacilityDetails from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/FacilityDetails';
import slider from '@PROJECT_ROOT/assets/shared/js/rangeSlider';
import StickyElement from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/StickyElement';
import verticalSmoothScrollToPosition from '@PROJECT_ROOT/assets/desktop/js/library/verticalSmoothScrollToPosition';
import { createFormStateHandler } from '@PROJECT_ROOT/assets/desktop/js/search/formRestore';
import { facilityCard, facilityCardSlideAnimation } from '@PROJECT_ROOT/assets/desktop/js/search/FacilityCard';
import { initComparedForSearchResults } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Compare';
import { initFavoritesForSearchResults } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Favorites';
import { showResultCount, setSubmitButtonToDefault } from '@PROJECT_ROOT/assets/desktop/js/search/searchResultCount';
import { triggerGoogleAnalyticsSendEvent, triggerAnalyticsSendPageView } from '@PROJECT_ROOT/assets/desktop/js/library/triggerGoogleAnalyticsSend';
import { urlChanged, scrollToTop, legacyScrollToTop } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';
import { validatePriceFields, validatePersonsField, markFieldAsNoError } from '@PROJECT_ROOT/assets/desktop/js/search/privateFilterValidation';
import initNearMe from '@PROJECT_ROOT/assets/desktop/js/search/private/nearMe';

const searchFilter = (function createSearchFilter($) {
    let $filtersForm;
    let filterFormHandler;
    let nearMeFilterHandler;
    let fetchPlacesForAutocomplete;
    let googleAutocompleteService;
    let getPlaceInfo;
    let priceSlider;
    const filterFormStateHandler = createFormStateHandler('SearchPrivateFilterForm');
    const quickFilterFormStateHandler = createFormStateHandler('quickFiltersSearchForm');

    function refreshDatePickers() {
        setFrom($('#SearchPrivateFilterForm_from').val());
        setTo($('#SearchPrivateFilterForm_to').val());
        toggleDateDeviationCheckboxDependingOnDateRange();
    }

    function initOtherAnalyticsEvents() {
        $(document).on('submit', '#SearchPrivateFilterForm', () => {
            const location = $('#SearchPrivateFilterForm_location').val();
            triggerGoogleAnalyticsSendEvent('Filteri', 'Traži_extended', location);
        });

        $(document).on('click', '#quickFiltersSubmit', () => {
            const location = $('#SearchPrivateFilterForm_location').val();
            triggerGoogleAnalyticsSendEvent('Rezultati pretrage', 'Traži', location);
        });
    }

    function submitFilterForm() {
        googleMapsLoaded.then(() => {
            $filtersForm.submit();
        });
    }

    function openFilterWindow() {
        const areFiltersAppendedToBody = $('body > .searchFilters').length;
        const submitButton = document.querySelector('#SearchPrivateFilterForm [type="submit"]');

        setSubmitButtonToDefault({
            submitButton,
            defaultText: submitButton.getAttribute('data-search-default-text'),
        })();

        if (!areFiltersAppendedToBody) {
            $('.searchFilters').appendTo('body');
        }

        filterFormStateHandler.rememberFormState();
        quickFilterFormStateHandler.rememberFormState();

        $('body > .searchFilters').show();
        $('body').css('overflow-y', 'hidden');
    }

    function closeFilterWindow() {
        // Filtere prebacujemo u .privateSearchResults div kako ne bi zaostao kada učitavamo novu pretragu preko pjaxa
        // (.privateSearchResults se ponovo učitava preko pjaxa). Bez ovoga bi imali dvije filter forme na stranici.
        $('.searchFilters').hide().appendTo('.privateSearchResults');

        $('body').css('overflow-y', 'auto');
    }

    function markActiveFilters() {
        $filtersForm.find('input[type=checkbox]:checked').each(function addClassActiveFilter() {
            $(this).parent().addClass('activeFilter');
        });
    }

    function categoryTooltips() {
        const { beach, family, robinson } = $('#categoryTooltips').data();

        const tooltipLabels = [];

        const beachCategory = document.querySelector('[for="SearchPrivateFilterForm_category_beach"]');
        const familyCategory = document.querySelector('[for="SearchPrivateFilterForm_category_family_friendly"]');
        const robinsonCategory = document.querySelector('[for="SearchPrivateFilterForm_category_robinson"]');

        beachCategory.setAttribute('title', beach);
        familyCategory.setAttribute('title', family);
        robinsonCategory.setAttribute('title', robinson);

        tooltipLabels.push(beachCategory);
        tooltipLabels.push(familyCategory);
        tooltipLabels.push(robinsonCategory);

        tooltipLabels.forEach((label) => { $(label).tooltip(); });
    }

    function isScrollBelowTopOfResults() {
        const topScroll = $(document).scrollTop();
        const topOfResults = $('.privateSearchResults').offset().top;

        return topScroll > topOfResults;
    }

    function scrollToTopOfResults() {
        const topOfResults = $('.privateSearchResults').offset().top;
        $(window).scrollTop(topOfResults);
    }

    /**
     * Za postavljanje departure i arrival datuma koristiti setTo() i setFrom() metode.
     *
     * @param {object} $datepicker
     * @param {mixed} newValue može biti falsy vrijednost, u tom slučaju se postavlja na prazno (null)
     */
    function setDatePicker($datepicker, newValue) {
        const currentDate = $datepicker.datepicker('getDate');

        // Ako je nova vrijednost prazna, svakako želimo poništiti datum
        if (!newValue) {
            $datepicker.datepicker('setDate', null);
        // fix za IE koji ponekad ponovo otvori datepicker dialog
        } else if (+currentDate !== +newValue) {
            $datepicker.datepicker('setDate', new Date(newValue));
        }
    }

    function updatePersonDistributionCheckboxAccordingToPersonCount(personCount) {
        $('#SearchPrivateFilterForm_p_dist').prop('disabled', false);
        $('#quickDistribution').prop('disabled', false);

        if (!Number(personCount)) {
            $('#SearchPrivateFilterForm_p_dist').prop('disabled', true);
            $('#quickDistribution').prop('disabled', true);
        }
    }

    function createGoogleMapsMap($mapSearch) {
        return new google.maps.Map(
            $mapSearch[0],
            {
                zoom: 8,
                minZoom: 7,
                center: { lat: 44.488, lng: 16.455 },
                disableDefaultUI: true,
                mapTypeControl: true,
                mapTypeControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT },
                zoomControl: true,
                scaleControl: true,
                streetViewControl: true,
                gestureHandling: 'cooperative',
                styles: getAdriaticStyles(),
            },
        );
    }

    /**
     * Koristi se samo za datepicker range onCloseTo event (tj. onClose event za jQuery datepicker). U ovom kontekstu
     * *this* je datepicker input polje.
     *
     * Želimo ažurirati *sve* to datepickere na zatvaranje jer se ponekad kod odabira from datuma to datepicker ažurira
     * sa prvim idućim datumom, ali se ne pokreće change event (ovo i ne želimo jer kod change eventa vršimo submit
     * forme). Radi se o internoj funkcionalnost Ad.Datepicker.initRange() metode.
     */
    function updateAllToDatepickers() {
        setTo($(this).datepicker('getDate'));
    }

    function setFromAndToDates(from, to) {
        const dates = filterFormHandler.calculateToAndFromDates(from, to);
        setFrom(dates.from);
        setTo(dates.to);
    }

    function setPersons(persons) {
        $('#SearchPrivateFilterForm_persons').val(persons);
        $('#quickPersons').val(persons);

        updatePersonDistributionCheckboxAccordingToPersonCount(persons);
    }

    function setDeviation(deviation) {
        $('#SearchPrivateFilterForm_deviation').prop('checked', deviation);
        $('#quickDeviation').prop('checked', deviation);
    }

    function setDistribution(distribution) {
        $('#SearchPrivateFilterForm_p_dist').prop('checked', distribution);
        $('#quickDistribution').prop('checked', distribution);
    }

    function setRadius(radius) {
        $('#SearchPrivateFilterForm_pl_r').val(radius);
        $('#quickRadius').val(radius);
    }

    function createMapSearch(map, mapSearchConfig) {
        const elements = {
            mapSearchContainer: document.querySelector(mapSearchConfig.selectors.mapSearch),
        };
        const urls = {
            results: mapSearchConfig.urls.results,
            facilityIcon: mapSearchConfig.urls.objectIcon,
            activeFacilityIcon: mapSearchConfig.urls.activeObjectIcon,
            facilitiesClusterIcon: mapSearchConfig.urls.clusterIcon,
            activeFacilitiesClusterIcon: mapSearchConfig.urls.activeClusterIcon,
            facilityPriceSmallIcon: mapSearchConfig.urls.facilityPriceSmallIcon,
            activeFacilityPriceSmallIcon: mapSearchConfig.urls.activeFacilityPriceSmallIcon,
            facilityPriceMediumIcon: mapSearchConfig.urls.facilityPriceMediumIcon,
            activeFacilityPriceMediumIcon: mapSearchConfig.urls.activeFacilityPriceMediumIcon,
            placeIcon: mapSearchConfig.urls.placeIcon,
        };
        const options = {
            fetchFilterData(bounds) {
                return getFilterDataWithUpdatedCoordinates(bounds);
            },
            facilityMarkerClick(marker) {
                showFacilityDetails(
                    mapSearchConfig.urls.details,
                    $(mapSearchConfig.selectors.detailsContainer),
                    $('#SearchPrivateFilterForm').serialize(),
                    marker,
                );
            },
            onFacilityMarkerFocus(marker) {
                showFacilityDetails(
                    mapSearchConfig.urls.details,
                    $(mapSearchConfig.selectors.detailsContainer),
                    $('#SearchPrivateFilterForm').serialize(),
                    marker,
                );
            },
            getInitialViewport() {
                return configureGetPrivateFilterForm()().getViewport();
            },
        };

        return new MapSearch(map, elements, urls, triggerGoogleAnalyticsSendEvent, jQuery, options);
    }

    function getFilterDataWithUpdatedCoordinates(bounds) {
        const formParameters = $('#SearchPrivateFilterForm').serializeArray();

        if (bounds === null) {
            return formParameters;
        }

        return formParameters.map((parameter) => {
            if (parameter.name === 'SearchPrivateFilterForm[ne_lat]') {
                return { ...parameter, value: bounds.getNorthEast().lat() };
            }

            if (parameter.name === 'SearchPrivateFilterForm[ne_lng]') {
                return { ...parameter, value: bounds.getNorthEast().lng() };
            }

            if (parameter.name === 'SearchPrivateFilterForm[sw_lat]') {
                return { ...parameter, value: bounds.getSouthWest().lat() };
            }

            if (parameter.name === 'SearchPrivateFilterForm[sw_lng]') {
                return { ...parameter, value: bounds.getSouthWest().lng() };
            }

            return parameter;
        });
    }

    function focusMapOnGoogleLocation(mapSearch, locationId) {
        const deferred = $.Deferred();
        const googlePlaceFound = function focusMapOnGooglePlace(name, location, viewport) {
            mapSearch.focusMapOnLocation(location, viewport)
                .done(() => {
                    deferred.resolve();
                })
                .fail((error) => {
                    deferred.reject(error);
                });
        };
        getPlaceInfo(locationId, googlePlaceFound, () => { deferred.resolve(); });

        return deferred.promise();
    }

    function setAllLocationTitlesToGoogleName(locationId) {
        const googlePlaceFoundCallback = function updateLocationTitlesWithGoogleName(name) {
            filterFormHandler.setLocation(name);
            $('#clearParamGooglePlaceTitle').text(name);
            const locationRadiusNotice = document.getElementById('googleLocationRadiusNotice');
            if (locationRadiusNotice) {
                locationRadiusNotice.textContent = name;
            }
        };
        const googlePlaceNotFoundCallback = () => {
            clearMapCoordinatesIfOurLocationSearch();
        };

        getPlaceInfo(locationId, googlePlaceFoundCallback, googlePlaceNotFoundCallback);
    }

    function displaySearchByMapInLocationInput() {
        $('.usingMap').show();
    }

    function clearMapCoordinatesIfOurLocationSearch(locationId) {
        if (!isGoogleLocationId(locationId) && locationId.length > 0) {
            filterFormHandler.clearMapCoordinatesFilter();
        }
    }

    function datepickerOptions(options) {
        return {
            openToAfterSelectingFromDate: true,
            onCloseTo: updateAllToDatepickers,
            allowKeyboardInput: false,
            deleteButton: { text: $('#quickFiltersSearchForm').data('clearbuttontext') },
            currentText: options.currentText,
        };
    }

    function toggleDateDeviationCheckboxDependingOnDateRange() {
        if ($('#SearchPrivateFilterForm_from').val() === '' || $('#SearchPrivateFilterForm_to').val() === '') {
            $('#SearchPrivateFilterForm_deviation').prop('disabled', true);
            $('#quickDeviation').prop('disabled', true);
        } else {
            $('#SearchPrivateFilterForm_deviation').prop('disabled', false);
            $('#quickDeviation').prop('disabled', false);
        }
    }

    function setLocationAsSelectedInQuickFilter(item, $quickFilterlocation, $quickFilterLocationId) {
        $quickFilterlocation.data('latestLocation', item.value);
        $('#SearchPrivateFilterForm_location').data('latestLocation', item.value);

        filterFormHandler.setLocation(item.value, item.id);
        filterFormHandler.setPlaceRadiusToDefaultIfNotSet();

        $quickFilterLocationId.change();
        $('#SearchPrivateFilterForm_location_id').change();
    }

    function hideSearchTitleAndEmptyLocation() {
        hideSearchTitle();
        filterFormHandler.setLocation('', '');
        // Treba pobrisat i nearMe filter kada se prelazi sa pretrage "U mojoj blizini" na pretragu po karti
        nearMeFilterHandler.clearNearMeCoordinates();
    }

    function hideSearchTitle() {
        $('#serviceContent').toggleClass('searchingByMap', true);
    }

    function showSearchTitle() {
        $('#serviceContent').toggleClass('searchingByMap', false);
    }

    function refreshPriceSlider() {
        const maximalPriceFormField = document.getElementById('SearchPrivateFilterForm_prc_max');
        const minimalPriceFormField = document.getElementById('SearchPrivateFilterForm_prc_min');

        priceSlider.setValues(
            minimalPriceFormField.value,
            parseInt(maximalPriceFormField.value, 10) === 0 ? 200 : maximalPriceFormField.value,
        );
    }

    function undoUserChangesToFilterFormSinceOpening() {
        filterFormStateHandler.restoreFormState();
        quickFilterFormStateHandler.restoreFormState();
        refreshDatePickers();
        refreshPriceSlider();
    }

    const privateFilter = {
        config: {
            defaultPlaceRadius: '',
            searchUrl: '',
            placesAutocompleteUrl: '',
            calendarUrl: '',
            privateFilterUrl: '',
            placeLocationData: null,
            mapSearch: {
                selectors: {
                    mapSearchContainer: '',
                    mapSearch: '',
                    detailsContainer: '',
                    details: '',
                    closeDetails: '',
                    controls: '',
                    listSyncToggle: '',
                    enterFullscreenMap: '',
                    exitFullscreenMap: '',
                    showFacilityOnMap: '',
                    syncListWithMapEnquiry: '',
                    closeSyncListWithMapEnquiry: '',
                    syncListWithMap: '',
                    dontSyncListWithMap: '',
                },
                disableClusters: false,
                urls: {
                    results: '',
                    details: '',
                    objectIcon: '',
                    activeObjectIcon: '',
                    clusterIcon: '',
                    activeClusterIcon: '',
                    facilityPriceIcon: '',
                    activeFacilityPriceIcon: '',
                },
                initialResults: [],
            },
            quickFilters: {
                selectors: {
                    filterBar: '',
                    selectedFilterParameters: '',
                    form: '',
                    location: '',
                    locationId: '',
                    from: '',
                    fromCalendarContainer: '',
                    to: '',
                    toCalendarContainer: '',
                    persons: '',
                    submit: '',
                },
            },
            datepickerOptions: {
                currentText: undefined,
            },
            isOurSiteUser: false,
        },
        mapSearch: null,
        shouldSearchWithinMapBounds: null,
        cachedPages: [],
        searchTimer: 0,
        requestNumber: 0,
        maxRadius: null,

        init(options) {
            const self = this;
            $filtersForm = $('#SearchPrivateFilterForm');
            filterFormHandler = configureGetPrivateFilterForm()();

            $.extend(self.config, options);

            const fetchGoogleAutocomplete = makeFetchExternalAutocomplete(() => googleAutocompleteService);
            const formatGooglePredictions = getFormatGooglePredictionsForAutocomplete(self.config.poweredByGoogleIcon);

            fetchPlacesForAutocomplete = configureFetchPlaces(
                $.post,
                self.config.placesAutocompleteUrl,
                fetchGoogleAutocomplete,
                formatGooglePredictions,
            );

            nearMeFilterHandler = initNearMe(
                self.config.nearMeFilterErrorMessages.errorMessage,
                self.config.nearMeFilterErrorMessages.browserErrorMessage,
            );

            // Mora biti prije inicijalizacije ostalih location eventova jer se na neke od njih vrši submit forme, pa
            // će se reset radijusa na default izvršiti prekasno.
            filterFormHandler.resetZeroPlaceRadiusToDefaultAfterLocationChange();
            filterFormHandler.hideDiscountChoicesNotOfferedToGuest();
            filterFormHandler.hideCategoryChoicesNotOfferedToGuest();
            filterFormHandler.hideFoodChoicesNotOfferedToGuest();

            priceSlider = self.initPriceRangeSlider(self.config.resultsCountUrl);
            self.initFilterEvents();
            self.initSelectedParamsEvents();
            self.initPagination();
            self.initQuickFilters();
            self.initSort();

            categoryTooltips();
            markActiveFilters();
            initOtherAnalyticsEvents();

            filterFormHandler.setPlaceRadiusToDefaultIfNotSet();
            toggleDateDeviationCheckboxDependingOnDateRange();

            googleAnalyticsSearchResults.init({ url: null, data: $('#gaSearchResultsData').data('ga-search-results') });

            if (loosenParameters($('#loosenedParameters').data('loosened-data'))) {
                submitFilterForm();
            }

            initShowResultCountOnFilterChangeEvents(self.config.resultsCountUrl);

            if (hasConflictingParameters()) {
                clearConflictingFormParameters();
                submitFilterForm();
            }
        },

        setupMapSearch(options) {
            const self = this;
            $.extend(self.config.mapSearch, options);

            const map = createGoogleMapsMap($(self.config.mapSearch.selectors.mapSearch));
            self.mapSearch = createMapSearch(map, self.config.mapSearch);

            googleAutocompleteService = new google.maps.places.AutocompleteService();
            getPlaceInfo = makeGetPlaceInfo(new google.maps.places.PlacesService(map), google.maps.places.PlacesServiceStatus);

            self.initMapSearchEvents();

            const locationId = filterFormHandler.getLocationId();
            if (isGoogleLocationId(locationId)) {
                setAllLocationTitlesToGoogleName(locationId);
            }

            self.initFullscreenMapSearchEvents();
            self.initListSyncToggleEvents();
            self.initListAndMapIntegrationEvents();
        },

        initMapSearchEvents() {
            const self = this;
            const { initialResults } = self.config.mapSearch;
            const { selectors } = self.config.mapSearch;

            self.mapSearch.onReady(() => {
                const locationId = filterFormHandler.getLocationId();

                if (isGoogleLocationId(locationId)) {
                    focusMapOnGoogleLocation(self.mapSearch, locationId);
                } else if (self.config.placeLocationData !== null) {
                    self.mapSearch.focusMapOnLocation(self.config.placeLocationData);
                } else if (filterFormHandler.isSearchByMap()) {
                    searchOnViewport(filterFormHandler.getViewport());
                } else if (document.getElementById('SearchPrivateFilterForm_nearMe').value === '1') {
                    const coordinates = nearMeFilterHandler.getNearMeCoordinates();
                    if (!coordinates) {
                        return;
                    }
                    self.mapSearch.focusMapOnLocation({
                        latitude: coordinates.latitude,
                        longitude: coordinates.longitude,
                    });
                } else {
                    self.mapSearch.setResults(initialResults, /* shouldFitAllResults */ true);
                }
            });

            $(window)
                .off('resize.mapSearch')
                .on('resize.mapSearch', () => {
                    $(selectors.mapSearch).width('100%');
                    self.mapSearch.resize();
                });
        },

        initListSyncToggleEvents() {
            const self = this;
            const { selectors } = self.config.mapSearch;

            // Odnosi se na botun kada je karta pored rezultata pretrage
            $(selectors.listSyncToggle).on('click', () => {
                $('#formPage').val(1);
                self.triggerSearch({ useMap: true });
                triggerGoogleAnalyticsSendEvent('RP-Mapa', 'Sync', 'On');
                $(selectors.listSyncToggle).hide();
            });
        },

        initListAndMapIntegrationEvents() {
            const self = this;
            const { selectors } = self.config.mapSearch;

            $(document)
                .off('click', selectors.showFacilityOnMap)
                .on('click', selectors.showFacilityOnMap, function onClickFocusOnFacility() {
                    const $this = $(this);

                    $('#formPage').val(1);
                    const facilityId = $this.data('facility-id');
                    const doubleFacilities = $this.data('double-facilities');
                    const facilityLat = $this.data('facility-lat');
                    const facilityLng = $this.data('facility-lng');

                    self.enterFullscreenMap($this, { useLocationFilter: false }).then(() => {
                        self.mapSearch.focusOnFacility(facilityId, doubleFacilities, facilityLat, facilityLng);
                    });
                });
        },

        initFullscreenMapSearchEvents() {
            const self = this;
            const { selectors } = self.config.mapSearch;

            $(document)
                .off('click', selectors.enterFullscreenMap)
                .on('click', selectors.enterFullscreenMap, function onClickSetGaqPush() {
                    scrollToTopPosition();
                    self.enterFullscreenMap($(this), { useLocationFilter: true });
                    triggerGoogleAnalyticsSendEvent('RP-Mapa', 'Pretrazi po karti', 'Otvori');
                });

            self.initExitFullscreenDialog();

            $(document)
                .off('click', selectors.dontSyncListWithMap)
                .on('click', selectors.dontSyncListWithMap, () => {
                    self.exitFullscreenMap();
                    triggerGoogleAnalyticsSendEvent('RP-Mapa', 'Pretrazi po karti', 'Zatvori no sync');
                    removeSyncWithMapDialogClickAwayListener();
                });

            // Sync toggle za situaciju kada je mapa fullscreen
            $(document)
                .off('click', selectors.syncListWithMap)
                .on('click', selectors.syncListWithMap, () => {
                    self.triggerSearch({ useMap: true });
                    self.exitFullscreenMap();
                    triggerGoogleAnalyticsSendEvent('RP-Mapa', 'Pretrazi po karti', 'Zatvori sync');
                    removeSyncWithMapDialogClickAwayListener();
                });
        },

        initExitFullscreenDialog() {
            const self = this;
            const { selectors } = self.config.mapSearch;
            const $syncListWithMapEnquiry = $(selectors.syncListWithMapEnquiry);
            const closeButton = document.querySelector(selectors.closeSyncListWithMapEnquiry);

            $(document)
                .off('click', selectors.exitFullscreenMap)
                .on('click', selectors.exitFullscreenMap, () => {
                    $syncListWithMapEnquiry.show();
                    addSyncWithMapDialogClickAwayListener();
                });

            closeButton.addEventListener('click', () => {
                $syncListWithMapEnquiry.hide();
                removeSyncWithMapDialogClickAwayListener();
            });
        },

        /**
         * @param {object} $target
         * @param {object} $options
         *
         * @return $.Deffered.promise() objekt koji kod resolve-a ne šalje nikakve podatke u success handler
         */
        enterFullscreenMap($target, options) {
            const self = this;
            const { selectors } = self.config.mapSearch;

            $('body').css('overflow', 'hidden');
            $('.simpleGallery img').css('-webkit-backface-visibility', 'visible');
            const $elementsToHideOnFullscreenMapView = $('#utilityBarWrap, #serviceHeader, #logo, #userLanguage');
            $elementsToHideOnFullscreenMapView.css('position', 'static');
            $(selectors.mapSearch).css({ width: '100%', height: '100%' });
            $(selectors.mapSearchContainer).show();
            $(selectors.controls).hide();

            const isFrameService = $('.fsMap').length;

            if (isFrameService) {
                const iFrameHeight = $('#serviceWrapper').height();
                const mapSearchHeight = $(selectors.mapSearch).height();
                const targetTop = $target.offset().top;

                let top = targetTop + mapSearchHeight / 2 < iFrameHeight
                    ? targetTop - mapSearchHeight / 2
                    : iFrameHeight - mapSearchHeight - 50;

                if (top < 0) {
                    top = 50;
                }

                $(selectors.mapSearchContainer).css('top', top);
            }

            return self.mapSearch.resize().then(() => {
                const locationId = filterFormHandler.getLocationId();
                if (isGoogleLocationId(locationId)) {
                    return focusMapOnGoogleLocation(self.mapSearch, locationId);
                }

                if (filterFormHandler.isSearchByMap()) {
                    return searchOnViewport(filterFormHandler.getViewport());
                }

                return self.mapSearch.updateAndForbidForMiliseconds(500, {
                    shouldFitAllResults: !filterFormHandler.isSearchByOurTown(),
                    useLocationFilter: options.useLocationFilter,
                });
            });
        },

        exitFullscreenMap() {
            const self = this;
            const { selectors } = self.config.mapSearch;

            $('body').css('overflow', 'auto');
            $('.simpleGallery img').css('-webkit-backface-visibility', 'hidden');
            const $elementsToHideOnFullscreenMapView = $('#utilityBarWrap, #serviceHeader, #logo, #userLanguage');
            $elementsToHideOnFullscreenMapView.css('position', 'relative');
            $(selectors.mapSearchContainer).hide();
            $(selectors.controls).show();
            $(selectors.syncListWithMapEnquiry).hide();
        },

        refreshMap() {
            const self = this;
            const deferred = $.Deferred();

            if (!self.mapSearch) {
                deferred.resolve();

                return deferred.promise();
            }

            const locationId = filterFormHandler.getLocationId();
            if (isGoogleLocationId(locationId)) {
                return focusMapOnGoogleLocation(self.mapSearch, locationId);
            }

            return self.mapSearch.updateAndForbidForMiliseconds(500, {
                shouldFitAllResults: !filterFormHandler.isSearchByMap() && !filterFormHandler.isSearchByPlace(),
                useLocationFilter: !filterFormHandler.isSearchByMap(),
            });
        },

        initQuickFilters() {
            const self = this;
            const { selectors } = self.config.quickFilters;

            self.initQuickLocationAutocomplete();
            Ad.Datepicker.initRange(selectors.from, selectors.to, datepickerOptions(self.config.datepickerOptions));

            if (self.config.isOurSiteUser) {
                self.stickQuickFiltersOnTopOnScrollPast();
            }

            $(selectors.form).on('submit', () => {
                submitFilterForm();
                return false;
            });

            $(selectors.location).on('keyup', function onKeyupSetLocation() {
                const location = $(this).val();
                filterFormHandler.setLocation(location);
            });

            /**
             * Moramo koristiti "placescompletechange" event umjesto običnog "change" eventa jer se "change" handler
             * pokreće prije "placescompleteclose" handlera i submita formu. Ovo nam je potrebno jer u slučaju kada
             * korisnik zatvori autocomplete a nije ništa odabrao želimo uzeti prvu lokaciju sa liste prije submita
             * (vidi self.initQuickLocationAutocomplete() metodu).
             */
            $(selectors.location).on('placescompletechange', () => {
                // Moguće ako google maps api još nije učitan
                if (!getPlaceInfo) {
                    submitFilterForm();
                    return;
                }

                const googlePlaceFound = (name, location, viewport) => {
                    filterFormHandler.setFilterMapCoordinates(viewport);
                    submitFilterForm();
                };
                const googlePlaceNotFound = () => {
                    clearMapCoordinatesIfOurLocationSearch(filterFormHandler.getLocationId());
                    // Vjerojatno se ovdje radi o našem mjestu, pa submitamo formu.
                    submitFilterForm();
                };

                getPlaceInfo($(selectors.locationId).val(), googlePlaceFound, googlePlaceNotFound);
            });

            $('.usingMap').on('click', function toggleUsingMap() {
                $('.usingMap').toggle(false);
                $(`#${$(this).data('inputid')}`).focus();
            });

            const $fromCalendarContainer = $(selectors.fromCalendarContainer);
            const $toCalendarContainer = $(selectors.toCalendarContainer);
            $fromCalendarContainer.on('change', () => {
                const from = $fromCalendarContainer.datepicker('getDate');
                setFrom(from);
                toggleDateDeviationCheckboxDependingOnDateRange();
                $fromCalendarContainer.blur();

                if ($toCalendarContainer.datepicker('getDate')) {
                    submitFilterForm();
                }
            });

            $toCalendarContainer.on('change', () => {
                const to = $toCalendarContainer.datepicker('getDate');
                setTo(to);

                // Ovo se registrira i kao change i keyup event handler za elemente .hasDatepicker klase, ali se
                // registracija tog handlera vrši nakon ovog koji može submitati formu, pa se može dogoditi da se
                // checkbox ne stigne ažurirati. Zato se ova funkcija poziva i ovdje.
                toggleDateDeviationCheckboxDependingOnDateRange();

                $toCalendarContainer.blur();

                if ($fromCalendarContainer.datepicker('getDate')) {
                    submitFilterForm();
                }
            });

            $(selectors.persons).on('change', function onChangePersonsSubmitForm() {
                const persons = $(this).val();
                setPersons(persons);
                submitFilterForm();
                $(this).blur();
            });

            self.syncQuickFiltersWithFilterForm();
            self.initQuickFilterEvents();

            if (filterFormHandler.isSearchByMap()) {
                hideSearchTitleAndEmptyLocation();
                displaySearchByMapInLocationInput();
            }
        },

        initSort() {
            const $sortField = $('#formSort');
            $(document).off('click', '.sortResults');
            $(document).off('click', '.sortTrigger');

            $(document).on('click', '.sortResults', function sortResultsClick() {
                $(this).find('ul').toggle(200);
            });

            $(document).on('click', '.sortTrigger', function sortTriggerClick(e) {
                const selectedSort = $(this).data('value');
                e.preventDefault();

                if ($(this).hasClass('disabled')) {
                    return false;
                }

                if ($sortField.val() !== selectedSort) {
                    showSelectedSort($(this));
                    toggleActiveSort($(this));

                    $sortField.val($(this).data('value')).change();
                    submitFilterForm();
                }

                return true;
            });

            function toggleActiveSort($selected) {
                $('.sortResults span.active').removeClass('active');
                $selected.addClass('active');
            }

            function showSelectedSort($selected) {
                const $selectedSortClone = $selected.clone().removeClass('sortTrigger');
                $('.sortResults>span').remove();
                $('.sortResults').prepend($selectedSortClone);
            }
        },

        syncQuickFiltersWithFilterForm() {
            const location = {
                name: $('#SearchPrivateFilterForm_location').val(),
                id: filterFormHandler.getLocationId(),
            };
            const from = $('#SearchPrivateFilterForm_from').val();
            const to = $('#SearchPrivateFilterForm_to').val();
            const persons = $('#SearchPrivateFilterForm_persons').val();
            const radius = $('#SearchPrivateFilterForm_pl_r').val();
            const deviation = $('#SearchPrivateFilterForm_deviation').prop('checked');
            const distribution = $('#SearchPrivateFilterForm_p_dist').prop('checked');

            filterFormHandler.setLocation(location.name, location.id);
            setFromAndToDates(from, to);
            setPersons(persons);
            setDeviation(deviation);
            setDistribution(distribution);
            setRadius(radius);
        },

        initQuickFilterEvents() {
            const self = this;
            const { selectors } = self.config.quickFilters;

            $(selectors.radius).on('change', function onChangeRadiusSubmitForm() {
                setRadius($(this).val());
                submitFilterForm();
            });

            $(selectors.deviation).on('change', function onChangeDeviationSubmitForm() {
                setDeviation($(this).prop('checked'));
                submitFilterForm();
            });

            $(selectors.distribution).on('change', function onChangeDistributionSubmitForm() {
                setDistribution($(this).prop('checked'));
                submitFilterForm();
            });

            $(selectors.location).on('change', function onChangeSetLocationId() {
                // Ako korisnik ručno izbriše unos (bez odabira lokacije)
                if ($(this).val() === '') {
                    filterFormHandler.setLocation('', '');
                    filterFormHandler.clearMapCoordinatesFilter();
                    nearMeFilterHandler.clearNearMeCoordinates();
                }

                submitFilterForm();
            });
        },

        initQuickLocationAutocomplete() {
            const self = this;
            const { selectors } = self.config.quickFilters;

            const $quickFilterlocation = $(selectors.location);
            const $quickFilterLocationId = $(selectors.locationId);
            const latestLocation = { id: $quickFilterlocation.val() };

            let userSelectedAnItem = false;
            let firstItem = null;

            $quickFilterlocation.placescomplete({
                source: fetchPlacesForAutocomplete,
                select(e, ui) {
                    userSelectedAnItem = true;
                    if (ui.item.id === 'nearMe') {
                        nearMeFilterHandler.setNearMeCoordinates().then(() => {
                            setLocationAsSelectedInQuickFilter(ui.item, $quickFilterlocation, $quickFilterLocationId);
                            // Potrebno je ponovo triggerati eventove (submit forme) koji se izvršavaju na defokusiranje
                            // polja jer se ovaj blok izvršava asinkrono
                            $quickFilterlocation.blur();
                        });
                    } else {
                        // Pobrisati eventualnu prijašnju pretragu
                        nearMeFilterHandler.clearNearMeCoordinates();

                        const oldLocationId = $quickFilterLocationId.val();
                        setLocationAsSelectedInQuickFilter(ui.item, $quickFilterlocation, $quickFilterLocationId);
                        // Potrebno submitati formu nakon svake promjene lokacije preko brzog filtera, ali change event
                        // kod kojeg se to radi je vezan za *location* polje umjesto *location id* polja. Ovo dovodi do
                        // toga da se change event ne pokrene kad mijenjamo lokaciju koja ima *različit id* ali
                        // *isti naziv* (npr. kada rivijera i mjesto imaju isto ime). Stoga ručno pokrećemo change event
                        // na location polju ako je id promijenjen.
                        if (ui.item.id !== oldLocationId) {
                            $quickFilterlocation.trigger('placescompletechange');
                        }

                        $quickFilterlocation.blur();
                    }
                },
                search() {
                    $('.ui-autocomplete').hide();
                },
                autoFocus: true,
                // Ovi eventovi su bitni za automatski odabir prvog elementa autocomplete popisa u slučaju kada je
                // korisnik zatvorio popis bez da je išta odabrao. Redoslijed pokretanja handlera je:
                // 1. response,
                // 2. open,
                // 3. select (neće se pokrenuti ako korisnik nije ništa odabrao),
                // 4. close
                close() {
                    // Ako korisnik na zatvaranje izbornika nije ništa odabrao, uzimamo prvi item iz liste od zadnje
                    // pretrage i to samo ako nije "U mojoj blizini"
                    if (!userSelectedAnItem && firstItem.id !== 'nearMe') {
                        // - firstItem nikad neće biti null jer se ovaj handler ne poziva u slučaju kada nema ništa u
                        // autocomplete prozoru
                        // - potrebno je pobrisati nearMe za scenarij kada se pretražuje "U mojoj blizini": pobriše se
                        // unos i započne pisanje neke druge lokacije, dobiju se prijedlozi ali korisnik odluči ne
                        // odabrati ništa. Ovo je lakše izvesti eksplicitno ovdje nego se oslanjati na change event.
                        nearMeFilterHandler.clearNearMeCoordinates();
                        setLocationAsSelectedInQuickFilter(firstItem, $quickFilterlocation, $quickFilterLocationId);
                    }
                },
                delay: 500,
                open() {
                    userSelectedAnItem = false;
                },
                response(event, ui) {
                    firstItem = ui.content.length > 0 ? ui.content[0].items[0] : null;
                },
            }).focus(function triggerNearMeSearch() {
                // Klik na polje nudi pretragu "U mojoj blizini"
                $(this).placescomplete('search', 'search_near_me');
            });

            Ad.Autocomplete.initCompleteList(selectors.location, latestLocation);
        },

        stickQuickFiltersOnTopOnScrollPast() {
            const self = this;
            const { selectors } = self.config.quickFilters;

            const stickyFilterBar = new StickyElement($(selectors.filterBar), $);
            const stickyFilters = new StickyElement($(selectors.selectedFilterParameters), $);
            const topBoundary = $('.filtersTogether').offset().top;

            stickyFilterBar.stickBelow(topBoundary, 'stickyFilterBar');
            stickyFilters.stickBelow(topBoundary, 'stickyFilters');
        },

        validate() {
            const persons = document.getElementById('SearchPrivateFilterForm_persons');
            const maxPrice = document.getElementById('SearchPrivateFilterForm_prc_max');
            const minPrice = document.getElementById('SearchPrivateFilterForm_prc_min');

            const personsValidation = validatePersonsField(persons)();
            const pricesValidation = validatePriceFields(minPrice, maxPrice)();

            return personsValidation && pricesValidation;
        },

        triggerSearch(options) {
            const self = this;

            self.cachedPages = [];

            if (!self.validate()) {
                return $.Deferred().resolve();
            }

            // zatvaramo filter prozor samo ako je validacija prošla
            closeFilterWindow();

            return self.delayedSearch(options);
        },

        delayedSearch(options) {
            // eslint-disable-next-line no-param-reassign
            options = $.extend({ preload: false, skipPushstate: false, useMap: false }, options);

            const self = this;

            if (options.preload) {
                return false;
            }

            Ad.Dom.abortRequests();
            const searchBarPosition = $('.filtersTogether').offset().top;
            const screenPosition = $(window).height() / 2;
            const loaderPosition = searchBarPosition + screenPosition;

            if ($('.filtersTogether').hasClass('stickyFilters')) {
                $('#presentationLoader').css('top', loaderPosition - 350);
            } else {
                $('#presentationLoader').css('top', 200);
            }

            $('#presentationOpacity').show();
            self.toggleRadiusSelection();
            // eslint-disable-next-line no-plusplus
            const thisRequestNumber = ++self.requestNumber;

            if (window.requestList.search && window.requestList.search.readyState !== 4) {
                window.requestList.search.abort();
            }

            if (options.useMap) {
                filterFormHandler.setFilterMapCoordinates(self.mapSearch.getBounds());
                hideSearchTitleAndEmptyLocation();
                displaySearchByMapInLocationInput();
                $('#formPage').val(1);
            } else {
                showSearchTitle();
            }

            const filters = $filtersForm.serializeArray();

            const location = $('#quickLocation').val();
            const locationIsSpecified = location !== '';
            const locationIsKnown = $('#SearchPrivateFilterForm_location_id').val() !== '';

            if (locationIsSpecified && !locationIsKnown) {
                filters.push({
                    name: 'SearchPrivateFilterForm[location]',
                    value: location,
                });
            }

            window.requestList.search = $.ajax({
                type: 'POST',
                global: true,
                url: self.config.searchUrl,
                data: filters,
                success(data) {
                    $('#presentationOpacity').hide();
                    // eslint-disable-next-line prefer-destructuring
                    let searchResults = data.searchResults;

                    if (typeof data.debugInfo !== 'undefined') {
                        searchResults += data.debugInfo;
                    }

                    if (typeof data.xmlInfo !== 'undefined') {
                        searchResults += data.xmlInfo;
                    }

                    document.title = data.title;
                    if (thisRequestNumber === self.requestNumber) {
                        $(window).unbind('scroll.mySearch');
                        $('#searchContent').html(searchResults).find('.tooltip').tooltip({
                            track: true,
                            position: { my: 'left+20 top+10', at: 'right bottom' },
                        });

                        facilityCardSlideAnimation()();
                        $('#selectedParameters').html(data.selectedParameters);

                        if (!options.skipPushstate) {
                            if (window.history.pushState) {
                                const pushStateUrl = data.currentUrl;

                                window.history.pushState({
                                    id: (new Date()).getTime(),
                                    container: '#serviceContent',
                                    url: pushStateUrl,
                                }, pushStateUrl, pushStateUrl);

                                document.title = data.title;

                                window.parent.window.postMessage(urlChanged(window.location.href), '*');
                                window.parent.window.postMessage(scrollToTop(), '*');
                                window.parent.window.postMessage(legacyScrollToTop(), '*');

                                window.everPushedSomething = true;
                                triggerAnalyticsSendPageView();
                            }
                        }
                    }

                    if (isScrollBelowTopOfResults()) {
                        scrollToTopOfResults();
                    }

                    if (loosenParameters($('#loosenedParameters').data('loosened-data'))) {
                        submitFilterForm();
                    }
                },
            }).done((data) => {
                const locationId = filterFormHandler.getLocationId();
                if (isGoogleLocationId(locationId)) {
                    setAllLocationTitlesToGoogleName(locationId);
                }

                if (data.location) {
                    self.mapSearch.focusMapOnLocation(data.location);
                }
            }).done((data) => {
                googleAnalyticsSearchResults.init({
                    url: data.currentUrl,
                    data: $('#gaSearchResultsData').data('ga-search-results'),
                });
            });

            window.requestList.search.then(() => {
                document.querySelectorAll('#searchResults > li[data-facility-id]').forEach((facility) => {
                    facilityCard({ facility })();
                });

                initComparedForSearchResults();
                initFavoritesForSearchResults();

                sendGoogleAnalyticsCustomDimensionsEvents();
            });

            return window.requestList.search;
        },

        startObjectListEntryAnimation() {
            $('#searchResults>li').each((index, el) => {
                setTimeout(() => {
                    $(el).addClass('slideUpAnimation');
                }, 100 * index);
            });
        },

        initFilterEvents() {
            const self = this;
            Ad.Datepicker.initRange(
                '#SearchPrivateFilterForm_from',
                '#SearchPrivateFilterForm_to',
                datepickerOptions(self.config.datepickerOptions),
            );

            $filtersForm.on('submit', () => {
                clearConflictingFormParameters();

                $('#formPage').val(1);
                self.triggerSearch({ useMap: filterFormHandler.isSearchByMap() });
                self.refreshMap();
                $(self.config.mapSearch.selectors.details).slideUp();

                return false;
            });

            $('.filterBtn').on('click', () => {
                openFilterWindow();
                triggerGoogleAnalyticsSendEvent('Filteri', 'otvori');
                self.disableFiltersByLocationAjax(filterFormHandler.getLocationId(), self.config.privateFilterUrl);

                return false;
            });

            $('#SearchPrivateFilterForm .clearParametersLink').on('click', () => {
                const { primary } = self.config.mainFilters;
                const primaryFilterSelectors = Object.keys(primary).map((index) => primary[index]);

                formClear(
                    'SearchPrivateFilterForm',
                    primaryFilterSelectors, // ne brišemo vrijednosti primarnih filtera
                );
                priceSlider.setValues(0, 200);

                showResultCountHelper(self.config.resultsCountUrl);
            });

            $('.searchFilters').on('click', (e) => {
                const targetIsFilterWindow = $('.innerSearchForm').is(e.target) || $('.innerSearchForm').has(e.target).length;

                if (!targetIsFilterWindow) {
                    undoUserChangesToFilterFormSinceOpening();
                    closeFilterWindow();
                }
            });

            $('.closeFilters').on('click', () => {
                undoUserChangesToFilterFormSinceOpening();
                closeFilterWindow();
            });

            $('#SearchPrivateFilterForm_from_visual').on('change', function onChangeArrival() {
                const from = $(this).datepicker('getDate');
                setFrom(from);
            });

            $('#SearchPrivateFilterForm_to_visual').on('change', function onChangeDeparture() {
                const to = $(this).datepicker('getDate');
                setTo(to);
            });

            // Google Analytics
            $filtersForm.on('submit', function pushGoogleAnalyticsEvent() {
                const $form = $(this);
                const $textAndSelectFields = $form.find('input[type="text"], select');
                const $checkboxes = $form.find('input[type="checkbox"]');

                $textAndSelectFields.each(function setGaqPushIfValueExist() {
                    const $textOrSelectField = $(this);

                    if ($textOrSelectField.val() && $textOrSelectField.val() !== '0') {
                        const value = Array.isArray($textOrSelectField.val())
                            ? $textOrSelectField.val().join(',')
                            : $textOrSelectField.val();

                        triggerGoogleAnalyticsSendEvent('Filteri', $textOrSelectField.attr('id'), value);
                    }
                });

                $checkboxes.each(function setGaqPushIfChecked() {
                    const $checkbox = $(this);

                    if ($checkbox.prop('checked')) {
                        const value = Array.isArray($checkbox.val())
                            ? $checkbox.val().join(',')
                            : $checkbox.val();

                        triggerGoogleAnalyticsSendEvent('Filteri', $checkbox.attr('id'), value);
                    }
                });
            });

            $('#SearchPrivateFilterForm_t_room').on('change', function onChangeAccommodationTypes() {
                $('#SearchPrivateFilterForm_kit_room').prop('disabled', !$(this).prop('checked'));
            }).change();

            $('.hasDatepicker').on('change keyup', toggleDateDeviationCheckboxDependingOnDateRange);

            $('#SearchPrivateFilterForm_persons').on('change keyup', function onChangePersons() {
                const newPersons = $(this).val();
                setPersons(newPersons);
                markFieldAsNoError('errorField', this.parentNode);
            }).change();

            $('#SearchPrivateFilterForm_prc_max').on('change keyup', () => {
                markFieldAsNoError('rowError', $('#SearchPrivateFilterForm_prc_max').parent()[0]);
            }).change();

            $('#SearchPrivateFilterForm_prc_min').on('change keyup', () => {
                markFieldAsNoError('rowError', $('#SearchPrivateFilterForm_prc_max').parent()[0]);
            }).change();

            self.toggleRadiusSelection();

            $('#SearchPrivateFilterForm_location').on('keyup', function onKeyUpLocation() {
                const location = $(this).val();
                let typingTimer = null;

                if (location === '') {
                    filterFormHandler.setLocation('', '');
                    filterFormHandler.clearMapCoordinatesFilter();
                } else {
                    filterFormHandler.setLocation(location);
                }

                clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    $(this).change();
                }, 1000);
            });

            $('#SearchPrivateFilterForm_deviation').on('change', function onChangeDeviation() {
                const deviation = $(this).prop('checked');
                setDeviation(deviation);
            });

            $('#SearchPrivateFilterForm_p_dist').on('change', function onChangeDistribution() {
                const distribution = $(this).prop('checked');
                setDistribution(distribution);
            });

            $('#SearchPrivateFilterForm_pl_r').on('change keyup', function onChangeRadius() {
                const radius = $(this).val();
                setRadius(radius);
            });

            $('#SearchPrivateFilterForm_location_id').on('change', function onChangeLocationId() {
                $('#SearchPrivateFilterForm_location').addClass('ui-autocomplete-loading');
                const googlePlaceFound = (name, location, viewport) => {
                    filterFormHandler.setFilterMapCoordinates(viewport);
                    $('#SearchPrivateFilterForm_location').removeClass('ui-autocomplete-loading');
                };
                const googlePlaceNotFound = () => {
                    clearMapCoordinatesIfOurLocationSearch(filterFormHandler.getLocationId());
                    $('#SearchPrivateFilterForm_location').removeClass('ui-autocomplete-loading');
                };

                $('#quickLocationId').val($(this).val());

                getPlaceInfo(filterFormHandler.getLocationId(), googlePlaceFound, googlePlaceNotFound);

                self.toggleRadiusSelection();
                self.disableFiltersByLocationAjax(filterFormHandler.getLocationId(), self.config.privateFilterUrl);
            });

            self.initLocationAutocomplete();

            $('#searchContent').on('click', '.searchObjectWrap a', function setCookie() {
                $.cookie(`order_${$(this).parents('.searchObjectWrap').attr('rel')}`, null, { path: '/' });
            });

            $('input[name="SearchPrivateFilterForm[food][]"]').on('change', ensureOnlyOneFoodTypeSelected);
        },

        initLocationAutocomplete() {
            const self = this;
            const quickFiltersSelectors = self.config.quickFilters.selectors;

            const $quickLocation = $(quickFiltersSelectors.location);
            const $quickLocationId = $(quickFiltersSelectors.locationId);
            const $location = $('#SearchPrivateFilterForm_location');
            const latestLocation = { id: $location.val() };
            const $autocomplete = $('.ui-autocomplete');

            $location.placescomplete({
                source: fetchPlacesForAutocomplete,
                select(e, ui) {
                    if (ui.item.id === 'nearMe') {
                        nearMeFilterHandler.setNearMeCoordinates();
                    }

                    setLocationAsSelectedInQuickFilter(ui.item, $quickLocation, $quickLocationId);
                    $location.blur();
                },
                search() {
                    $autocomplete.hide();
                },
                autoFocus: true,
                delay: 500,
                change(event, ui) {
                    if (ui.item === null || ui.item.id !== 'nearMe') {
                        // Ako korisnik ručno izbriše unos (bez odabira lokacije) ili odabere drugu lokaciju
                        nearMeFilterHandler.clearNearMeCoordinates();
                    }
                },
            }).focus(function triggerNearMeSearch() {
                // Klik na polje nudi pretragu "U mojoj blizini"
                $(this).placescomplete('search', 'search_near_me');
            });

            Ad.Autocomplete.initCompleteList('#SearchPrivateFilterForm_location', latestLocation);
        },

        disableFiltersByLocationAjax($locationId, $url) {
            $.post($url, {
                location_id: [$locationId],
            }).then((data) => {
                privateFilter.disableFiltersByLocation(data);
            });
        },

        initPagination() {
            const self = this;

            $('#pjaxHolder').on('click', '.searchPaginationList a', function clickOnSearchPaginationList(e) {
                if (self.config.subscribePagination !== false && !e.ctrlKey && !e.shiftKey) {
                    if ($('#formPage').length > 0) {
                        e.preventDefault();

                        const page = parseInt($(this).data('page'), 10);
                        const currentPage = parseInt($('.searchPaginationList .active').data('page'), 10);

                        if (page !== currentPage) {
                            if (window.requestList.search && window.requestList.search.readyState !== 4) {
                                window.requestList.search.abort();
                            }

                            if (page === currentPage + 1) {
                                delete self.cachedPages[currentPage - 1];
                            } else if (page === currentPage - 1) {
                                delete self.cachedPages[currentPage + 1];
                            } else if (page === currentPage + 2) {
                                delete self.cachedPages[currentPage - 1];
                                delete self.cachedPages[currentPage];
                            } else if (page === currentPage - 2) {
                                delete self.cachedPages[currentPage + 1];
                                delete self.cachedPages[currentPage];
                            } else {
                                self.cachedPages = {};
                            }

                            $('#formPage').val(page);

                            self.delayedSearch({ skipPushState: true });

                            if (window.history.pushState) {
                                const $this = $(this);
                                const pushStateUrl = $this.data('url') ? $this.data('url') : $this.attr('href');

                                window.history.pushState({
                                    id: (new Date()).getTime(),
                                    container: '#serviceContent',
                                    url: pushStateUrl,
                                }, pushStateUrl, pushStateUrl);

                                window.everPushedSomething = true;
                                triggerAnalyticsSendPageView();

                                window.parent.window.postMessage(urlChanged(window.location.href), '*');
                            }
                        }
                    }
                }
            });
        },

        initPriceRangeSlider(resultsCountUrl) {
            const maximalPriceFormField = document.getElementById('SearchPrivateFilterForm_prc_max');
            const minimalPriceFormField = document.getElementById('SearchPrivateFilterForm_prc_min');
            const minimalPriceUIHolder = document.getElementById('minimalPrice');
            const maximalPriceUIHolder = document.getElementById('maximalPrice');

            return slider({
                elementId: 'priceRangeSlider',
                initialMin: minimalPriceFormField.value ? minimalPriceFormField.value : 0,
                initialMax: maximalPriceFormField.value ? maximalPriceFormField.value : 200,
                onUpdateCallback: debounce((minimalSelectedPrice, maximalSelectedPrice) => {
                    if (maximalSelectedPrice >= 200) {
                        maximalPriceUIHolder.innerText = '200+';
                        maximalPriceFormField.value = 0;
                    } else {
                        maximalPriceUIHolder.innerText = maximalSelectedPrice;
                        maximalPriceFormField.value = maximalSelectedPrice;
                    }

                    minimalPriceUIHolder.innerText = minimalSelectedPrice;
                    minimalPriceFormField.value = minimalSelectedPrice;

                    if (privateFilter.validate()) {
                        showResultCountHelper(resultsCountUrl);
                    }
                }, 100),
            });
        },

        initSelectedParamsEvents() {
            $('#pjaxHolder').on('click', '.clearSelectedParameter', function clearSelectedParameter() {
                const inputId = $(this).attr('id').replace('_selected', '');
                const type = $(`#${inputId}`).prop('type');

                // Za nearMe je potrebno obaviti isto što i za lokaciju jer je to zapravo jedna od ponuđenih "lokacija"
                if (inputId.match(/SearchPrivateFilterForm_location/g) || inputId === 'SearchPrivateFilterForm_nearMe') {
                    let locations = $('span[id^=SearchPrivateFilterForm_location]');
                    filterFormHandler.setLocation('', '');
                    filterFormHandler.clearMapCoordinatesFilter();

                    // Kada je više botuna za poništavanje filtera lokacije (npr. Dalmacija je zapravo 3 različite regije)
                    if (locations.length > 1) {
                        // Uklanja botun koji je kliknut u svrhu isključivanja filtera (određene lokacije)
                        $(this).parent().remove();

                        // Ponovo dohvaćamo popis lokacija nakon što smo uklonili filter kako bi izračunali novu
                        // vrijednost locationId-ja (bez uklonjene lokacije) za input polje
                        locations = $('span[id^=SearchPrivateFilterForm_location]');
                        let locationId = '';
                        const separator = '|';

                        for (let i = 0; i < locations.length; i += 1) {
                            if (i !== 0) {
                                locationId += separator;
                            }
                            locationId += $(locations[i]).data('id');
                        }

                        $('#SearchPrivateFilterForm_location_id').val(locationId).change();
                    } else {
                        $('#SearchPrivateFilterForm_location_id').change();
                        $('#SearchPrivateFilterForm_pl_r').change();
                    }
                }

                if (type === 'checkbox') {
                    $(`#${inputId}`).prop('checked', false).change();
                } else if (
                    inputId === 'SearchPrivateFilterForm_persons'
                    || inputId === 'SearchPrivateFilterForm_prc_min'
                    || inputId === 'SearchPrivateFilterForm_prc_max'
                ) {
                    $(`#${inputId}`).prop('value', '').keyup();
                    if (inputId === 'SearchPrivateFilterForm_persons') {
                        $('#SearchPrivateFilterForm_p_dist').prop('checked', false).change();
                        $('#SearchPrivateFilterForm_p_dist').prop('disabled', true).change();
                    }
                } else if (inputId === 'SearchPrivateFilterForm_from') {
                    setFromAndToDates(null, null);
                    $(`#${inputId}`).change();
                    $('#SearchPrivateFilterForm_deviation').prop('checked', false).prop('disabled', true).change();
                    $('#quickDeviation').prop('disabled', true);
                } else if (inputId === 'SearchPrivateFilterForm_pl_r') {
                    $('#SearchPrivateFilterForm_pl_r').val('0').change();
                } else if (inputId === 'SearchPrivateFilterForm_dc_t_all_discounts') {
                    $('#SearchPrivateFilterForm_dc_t').prop('checked', false).change();
                } else if (inputId === 'SearchPrivateFilterForm_nearMe') {
                    nearMeFilterHandler.clearNearMeCoordinates();
                } else if (inputId === 'SearchPrivateFilterForm_search_by_map') {
                    $('#SearchPrivateFilterForm_ne_lat').prop('value', '');
                    $('#SearchPrivateFilterForm_ne_lng').prop('value', '');
                    $('#SearchPrivateFilterForm_sw_lat').prop('value', '');
                    $('#SearchPrivateFilterForm_sw_lng').prop('value', '');
                    $('.usingMap').hide();
                } else {
                    $(`#${inputId}`).prop('value', '').change();
                }

                submitFilterForm();
            });
        },

        toggleRadiusSelection() {
            const self = this;
            const locationId = filterFormHandler.getLocationId();
            const { selectors } = self.config.quickFilters;
            if (locationId.substr(0, 3) === 'pl-' || isGoogleLocationId(locationId)) {
                $('#filterAccommodationPlaceMaxRadius').removeClass('hide');
                $('#SearchPrivateFilterForm_pl_r').prop('disabled', false);
                $(selectors.radius).prop('disabled', false);
                $(selectors.radiusWrap).removeClass('disabled');
            } else {
                $('#filterAccommodationPlaceMaxRadius').addClass('hide');
                $('#SearchPrivateFilterForm_pl_r').prop('disabled', true);
                $(selectors.radius).prop('disabled', true);
                $(selectors.radiusWrap).addClass('disabled');
            }
        },

        disableFiltersByLocation(privateFilterObject) {
            const $beachType = $('input[type="checkbox"][id*="SearchPrivateFilterForm_be_t_"]');
            const $land = $('input[type="checkbox"][id*="SearchPrivateFilterForm_land_"]');
            const $beachDistance = $('#SearchPrivateFilterForm_be_d');
            const $beachParametersWrapper = $('#beachParametersWrapper');

            if (privateFilterObject.beachParameterDisabled) {
                $beachParametersWrapper.addClass('hide');
                $beachDistance.val('');
                $beachType.prop('checked', false);
            } else {
                $beachParametersWrapper.removeClass('hide');
            }

            if (privateFilterObject.landParameterDisabled) {
                $('#filterAccommodationLandTypeSelect').addClass('hide');
                $land.prop('checked', false);
            } else {
                $('#filterAccommodationLandTypeSelect').removeClass('hide');
            }
        },
    };

    function setFrom(from) {
        setDatePicker($(privateFilter.config.quickFilters.selectors.fromCalendarContainer), from);
        setDatePicker($('#SearchPrivateFilterForm_from_visual'), from);
    }

    function setTo(to) {
        const quickFilterSelectors = privateFilter.config.quickFilters.selectors;

        /**
         * Postavljamo min date na departure datepickere ako je departure datum zadan jer jQuery UI datepicker inače ne
         * dopušta promjenu datuma na ispod minDate.
         *
         * Inače initRange handle-a ispravno postavljanje minDate property-ja onda kada korisnik promjeni arrival (from)
         * datum, ali u slučaju pretrage imamo dva datepicker range-a koji trebaju biti sinkronizirani, pa kada korisnik
         * promjeni onaj u filter formi, ne ažurira se minDate u quick formi jer je programatski promijenjen (nije ga
         * promijenio korisnik eksplicitno).
         *
         * Bug koji ove dvije linije kôda ispravljaju:
         * 1. dođemo na stranicu pretrage bez ikakvih datuma
         * 2. unesemo from i to datume u quick formi
         * 3. nakon što se izvršila nova pretraga otvorimo filter formu i odaberemo novi from-to raspon koji je *cijeli*
         * prije početka starog raspona
         * 4. to datum u quick formi će ostati na vrijednosti from datuma +1 dan od raspona unesenog u koraku 2.
         */
        $(quickFilterSelectors.toCalendarContainer).datepicker('option', 'minDate', null);
        $('#SearchPrivateFilterForm_to_visual').datepicker('option', 'minDate', null);

        $(quickFilterSelectors.toCalendarContainer).datepicker('setDate', to ? new Date(to) : null);
        $('#SearchPrivateFilterForm_to_visual').datepicker('setDate', to ? new Date(to) : null);
    }

    function searchOnViewport(viewport) {
        return privateFilter.mapSearch.searchOnViewport(viewport.getGoogleLiteral()).done(() => {
            hideSearchTitleAndEmptyLocation();
            displaySearchByMapInLocationInput();
        });
    }

    function sendGoogleAnalyticsCustomDimensionsEvents() {
        const facilityIds = $('#searchResults').data('facility-ids');

        Ad.GAdimensions.sendHrental(
            facilityIds ? facilityIds.join(',') : '',
            'searchresults',
            '',
            $('#SearchPrivateFilterForm_from').val(),
            $('#SearchPrivateFilterForm_to').val(),
        );
    }

    function initShowResultCountOnFilterChangeEvents(url) {
        function validateAndShowResultCount() {
            if (privateFilter.validate()) {
                showResultCountHelper(url);
            }
        }

        $('#SearchPrivateFilterForm').on('change', ':input', debounce(validateAndShowResultCount, 150));
    }

    function scrollToTopPosition() {
        const windowScrollTop = window.scrollY;
        const windowScrollTopIe = window.pageYOffset;

        if (windowScrollTop || windowScrollTopIe < 200) {
            verticalSmoothScrollToPosition($('html, body'), 200, 0);
        }
    }

    return privateFilter;
}(jQuery));

function showResultCountHelper(url) {
    const submitButton = document.querySelector('#SearchPrivateFilterForm [type="submit"]');
    const filters = $('#SearchPrivateFilterForm').serializeArray();

    showResultCount()({
        url,
        filters,
        submitButton,
        text: {
            default: submitButton.getAttribute('data-search-default-text'),
            noResults: submitButton.getAttribute('data-no-results-text'),
            foundResults: submitButton.getAttribute('data-results-found-text'),
            useOptionMultipleUnits: submitButton.getAttribute('data-use-multiple-units-allowed'),
        },
    });
}

function syncWithMapDialogClickAwayListener(event) {
    const closeSyncNotification = document.querySelector('.syncNotification');
    const closeSyncButton = document.querySelector('.closeMap');

    if (!closeSyncNotification.contains(event.target) && !closeSyncButton.contains(event.target)) {
        closeSyncNotification.style.display = 'none';
        removeSyncWithMapDialogClickAwayListener();
    }
}

function addSyncWithMapDialogClickAwayListener() {
    document.addEventListener('click', syncWithMapDialogClickAwayListener);
}

function removeSyncWithMapDialogClickAwayListener() {
    document.removeEventListener('click', syncWithMapDialogClickAwayListener);
}

function ensureOnlyOneFoodTypeSelected() {
    const currentlySelectedType = this;
    document.querySelectorAll('input[name="SearchPrivateFilterForm[food][]').forEach((foodType) => {
        if (foodType !== currentlySelectedType) {
            foodType.checked = false;
        }
    });
}

export default searchFilter;
